<template>
	<div class="notifications-section" data-testid="notifications-section">
		<div class="notifications-container" data-testid="notifications-container">
			<NotificationBox title="Notificações" :items="notifications" empty-message="Nenhuma notificação encontrada"
				:limit="5" @export-attachment="$emit('export-attachment', $event)" data-testid="notifications-box" />

			<NotificationBox title="Controle de Versões" :items="versionsControl"
				empty-message="Nenhuma atualização encontrada" :limit="5"
				@export-attachment="$emit('export-attachment', $event)" data-testid="version-control-box" />
		</div>
	</div>
</template>

<script>
import NotificationBox from './NotificationBox.vue'
import BellOutline from 'icons/BellOutline'

export default {
	name: 'NotificationsSection',
	components: {
		NotificationBox,
		BellOutline
	},
	data() {
		return {
			notifications: [],
			versionsControl: [],
		}
	},
	async created() {
		await this.fetchNotifications()
	},
	methods: {
		async fetchNotifications(type) {
			await Promise.all([
				this.$store.dispatch('fetchFilteredNotificacoes', {
					http: this.$http,
					page: 1,
					type: 'notification',
					limit: 5,
				}),
				this.$store.dispatch('fetchFilteredNotificacoes', {
					http: this.$http,
					page: 1,
					type: 'version_control',
					limit: 5,
				}),
			])

			this.notifications = this.$store.getters['notificacoes']
			this.versionsControl = this.$store.getters['changelogs']
		},
	}
}
</script>

<style lang="scss" scoped>
.notifications-section {
	margin-bottom: 2rem;

	.notifications-header {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 1rem;

		.view-all-btn {
			background-color: #ffc20e;
			color: #202224;
			border: none;
			border-radius: 8px;
			padding: 0.75rem 1.5rem;
			font-size: 0.875rem;
			font-weight: 600;
			cursor: pointer;
			transition: all 0.2s ease;

			&:hover {
				background-color: #e6ae0c;
				transform: translateY(-1px);
			}

			&:active {
				transform: translateY(0);
			}
		}

		@media only screen and (max-width: 780px) {
			justify-content: center;

			.view-all-btn {
				padding: 0.5rem 1.25rem;
				font-size: 0.8rem;
			}
		}
	}

	.notifications-container {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;

		>div {
			flex: 1;
			min-width: 300px;
		}

		@media only screen and (max-width: 780px) {
			flex-direction: column;

			>div {
				min-width: 100%;
			}
		}
	}
}
</style>